import { normalizePath } from './normalizePath';

export const isLongPath = (path: string) => {
  const normalized = normalizePath(path);

  return normalized.split('/').length > 1;
};
